const entry = (name, category, count) => ({ name, category, count });

// Dossier-supplied images not already used elsewhere in each concept.
// Exact duplicates were removed before publication.
export const BUSINESS_MEDIA = {
  "/ac-tajanlangit-construction-concept": entry("A.C. Tajanlangit Construction", "project portfolio", 5),
  "/alexis-construction-concept": entry("Alexis Construction", "project portfolio", 4),
  "/algon-engineering-construction-concept": entry("Algon Engineering Construction", "project portfolio", 7),
  "/constantin-design-build-concept": entry("Constantin Design & Build", "project portfolio", 6),
  "/cubeworx-builders-concept": entry("Cubeworx Builders", "project portfolio", 4),
  "/dpx-negros-construction-concept": entry("DPX Construction", "project portfolio", 5),
  "/egi-construction-concept": entry("E.G.I. Construction", "project portfolio", 3),
  "/k-elman-construction-concept": entry("K. Elman Construction", "project portfolio", 4),
  "/megward-construction-concept": entry("Megward Construction", "project portfolio", 3),
  "/rkd-plus-construction-concept": entry("RKD Plus Construction", "project portfolio", 5),
  "/tuanson-construction-concept": entry("Tuanson Construction", "company portfolio", 1),

  "/21-dental-clinic-concept": entry("21 Dental Clinic", "clinical work", 6),
  "/baroquina-dental-concept": entry("Baroquina Dental Clinic", "clinic and treatment gallery", 4),
  "/beyond-smile-dental-concept": entry("Beyond Smile Dental", "clinical work", 5),
  "/blacano-dental-concept": entry("Blacano Dental Center", "clinic and treatment gallery", 6),
  "/cf-dental-concept": entry("C&F Dental Care", "clinic and treatment gallery", 3),
  "/cedro-dental-concept": entry("Cedro Dental Clinic", "clinic and treatment gallery", 5),
  "/city-smile-dental-concept": entry("City Smile Dental", "clinical work", 7),
  "/family-tree-dental-concept": entry("Family Tree Dental Care", "clinic and treatment gallery", 4),
  "/gallinero-dental-concept": entry("Gallinero Dental Center", "clinic and treatment gallery", 5),
  "/ong-dental-concept": entry("Ong Dental Clinic", "clinic and treatment gallery", 2),
  "/orevillos-dental-concept": entry("Orevillo's Dental Clinic", "clinic and treatment gallery", 7),
  "/smiles-dental-concept": entry("Smiles Dental Care", "clinic gallery", 2),
  "/st-michaels-dental-concept": entry("St. Michael's Dental Care", "clinical work", 7),
  "/tooth-doctors-dental-concept": entry("Tooth Doctors Dental Clinic", "clinic and treatment gallery", 5),

  "/helen-jewelry-shop-concept": entry("Helen Jewelry Shop", "jewelry collection", 4),
  "/ty-po-huat-goldsmith-concept": entry("Ty Po Huat Goldsmith", "jewelry collection", 5),
  "/mayfair-goldsmith-concept": entry("Mayfair Goldsmith", "jewelry collection", 5),
  "/rb-jewelry-concept": entry("RB Jewelry", "jewelry collection", 5),
  "/cebu-gold-pacific-concept": entry("Cebu Gold & Glitz", "jewelry collection", 5),
  "/myrnas-jewelry-concept": entry("Myrna's Jewelry", "jewelry collection", 6),
  "/agencia-belen-pawnshop-concept": entry("Agencia Belen Pawnshop", "jewelry collection", 7),
  "/belcina-jewelry-concept": entry("Belcina Jewelry", "jewelry collection", 6),
  "/jehannah-goldsmith-concept": entry("Jehannah Goldsmith", "jewelry collection", 5),
};

export function mediaForPath(pathname) {
  const key = pathname.toLowerCase().replace(/\/$/, "") || "/";
  const item = BUSINESS_MEDIA[key];
  if (!item) return null;
  return {
    ...item,
    images: Array.from({ length: item.count }, (_, index) => ({
      src: `/research-media${key}/media-${String(index + 1).padStart(2, "0")}.jpg`,
      webp: `/research-media${key}/media-${String(index + 1).padStart(2, "0")}.webp`,
      thumbnail: `/research-media${key}/media-${String(index + 1).padStart(2, "0")}-720.webp`,
      alt: `${item.name} ${item.category} image ${index + 1}`,
    })),
  };
}
